import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  GlobalSearchRecentItem,
  type GlobalSearchRecentItemConstructor,
} from './GlobalSearchRecentItem'
import { GlobalSearchResultStatuses, GlobalSearchResultTypes } from '../enums'

// Default shape is ORDER_REQUEST. Tests for other types must override
// both `type` and `metadata` to produce a valid combination.
export const GlobalSearchRecentItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchRecentItemConstructor>({
    type: GlobalSearchResultTypes.ORDER_REQUEST,
    uuid: Factory.each(() => faker.random.uuid()),
    id: Factory.each(() => String(faker.random.number())),
    metadata: Factory.each(() => ({
      status: faker.random.arrayElement([
        GlobalSearchResultStatuses.PENDING_APPROVAL,
        GlobalSearchResultStatuses.APPROVED,
        GlobalSearchResultStatuses.DENIED,
        GlobalSearchResultStatuses.PURCHASED,
        GlobalSearchResultStatuses.RECEIVED,
      ]),
      date: faker.date.recent().toISOString(),
    })),
    lastAccessedAt: Factory.each(() => faker.date.recent().toISOString()),
  })

export const GlobalSearchRecentItemFactory = EntityFactory(
  GlobalSearchRecentItem,
  GlobalSearchRecentItemConstructorFactory
)
